import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selDisplayedInIds: [],
};

const serviceSlice = createSlice({
  name: "getService",
  initialState: initialState,
  reducers: {
    onDisplayedInEdit: (state, action) => {
      try {
        let data = action.payload;
        if (data) {
          let selDisplayedInIds = data ? data.split(",") : [];
          state.selDisplayedInIds = selDisplayedInIds;
        } else {
          state.selDisplayedInIds = [];
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
});

export const { onDisplayedInEdit } = serviceSlice.actions;
export default serviceSlice.reducer;
